$('.inviewPulse').each(function(index, val) {
  var inviewPulse = new Waypoint.Inview({
    element: $(this),
    enter: function(direction) {

    },
    entered: function(direction) {
      console.log('entered')
      $(this.element[0]).addClass('pulse')
    },
    exit: function(direction) {

    },
    exited: function(direction) {
      $(this.element[0]).removeClass('pulse')
    }
  })
});

$('.inviewPulseSmall').each(function(index, val) {
  var inviewPulse = new Waypoint.Inview({
    element: $(this),
    enter: function(direction) {

    },
    entered: function(direction) {
      console.log('entered')
      $(this.element[0]).addClass('pulsesmall')
    },
    exit: function(direction) {

    },
    exited: function(direction) {
      $(this.element[0]).removeClass('pulsesmall')
    }
  })
});

$('.inviewGrow').each(function(index, val) {
  var inviewPulse = new Waypoint.Inview({
    element: $(this),
    enter: function(direction) {

    },
    entered: function(direction) {
      console.log('entered')
      $(this.element[0]).addClass('grow')
    },
    exit: function(direction) {

    },
    exited: function(direction) {
      $(this.element[0]).removeClass('grow')
    }
  })
});